import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
} from '@angular/router';
import { LocationCode } from '@geneplanet/ngx-utils/src/lib/localization';
import { environment } from 'src/environments/environment';

type FeatureFlag = boolean | Partial<Record<LocationCode, boolean>>;

const features: Record<string, FeatureFlag> = environment.features;

@Injectable({ providedIn: 'root' })
/**
 * @deprecated Instead use `canViewFeature` functional guard, which supports localization
 */
export class FeatureFlagGuard implements CanActivateChild, CanActivate {
  private readonly router = inject(Router);

  static isFeatureActive(feature: string): boolean {
    const value = features[feature];

    // By default feature is active
    if (value === undefined) {
      return true;
    }

    return value as boolean;
  }

  canActivate(route: ActivatedRouteSnapshot) {
    if (!FeatureFlagGuard.isFeatureActive(route.data.feature)) {
      return this.router.parseUrl('/');
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot) {
    return this.canActivate(route);
  }
}
